<template>
  <div class="asd20-share">
    <asd20-button
      icon="share-alt"
      size="sm"
      label="Share"
      horizontal
      hide-label
      @click.native="share"
    ></asd20-button>
    <div v-show="showMenu" class="share-menu">
      <h2>Share this on:</h2>
      <asd20-button
        @click.native="
          openShareLink(
            'https://twitter.com/intent/tweet?url={url}&text={title}&via=AcademyD20'
          )
        "
        icon="twitter"
        size="sm"
        label="X"
        horizontal
      ></asd20-button>

      <asd20-button
        @click.native="
          openShareLink('https://www.facebook.com/sharer/sharer.php?u={url}')
        "
        icon="facebook"
        size="sm"
        label="Facebook"
        horizontal
      ></asd20-button>

      <asd20-button
        @click.native="
          openShareLink('mailto:?subject={title}&body=Check this out: {url}')
        "
        icon="email"
        size="sm"
        label="Email"
        horizontal
      ></asd20-button>

      <hr style="padding: 0; margin: 0; border-top: 1px solid #00000011" />

      <asd20-button
        @click.native="copyToClipboard"
        icon="files"
        size="sm"
        label="Copy Summary"
        horizontal
      ></asd20-button>
    </div>
  </div>
</template>

<script>
import Asd20Button from '../../atoms/Asd20Button'
export default {
  name: 'Asd20Share',

  components: { Asd20Button },

  data: () => ({
    showMenu: false,
  }),

  methods: {
    share() {
      // if (typeof window !== undefined && navigator.share) {
      //   const h1 = document.getElementsByTagName('h1')[0]
      //   const pageTitle = document.getElementsByTagName('title')[0]
      //   const title = h1 ? h1.innerText : pageTitle.text
      //   const url = document.querySelector('link[rel=canonical]')
      //     ? document.querySelector('link[rel=canonical]').href
      //     : document.location.href

      //   this.showMenu = false

      //   navigator
      //     .share({
      //       title,
      //       url,
      //     })
      //     .then(() => {
      //       console.log('Thanks for sharing!')
      //     })
      //     .catch(console.error)
      // } else {
      this.showMenu = !this.showMenu
      // }
    },
    openShareLink(urlTemplate) {
      this.showMenu = false
      if (typeof window !== undefined) {
        const h1 = document.getElementsByTagName('h1')[0]
        const pageTitle = document.getElementsByTagName('title')[0]
        const url = document.querySelector('link[rel=canonical]')
          ? document.querySelector('link[rel=canonical]').href
          : document.location.href
        const title = h1 ? h1.innerText : pageTitle.text
        window.open(
          urlTemplate.replace(/{title}/gim, title).replace(/{url}/gim, url),
          '_blank'
        )
      }
    },
    copyToClipboard() {
      const h1 = document.querySelector('.asd20-page-header__title-content h1')
        .textContent
      const summary = document.querySelector('.asd20-page-header__lead')
        .textContent
      const url = window.location.href
      const text = `${h1}\n\n${summary}\nRead more:\n${url}\n\n`
      const callsToAction = Array.from(
        document.querySelectorAll('.asd20-page-header__call-to-action a')
      )
        .map(a => ({ title: a.textContent, url: a.href }))
        .map(l => `<li><a href="${l.url}">${l.title}</a></li>`)
        .join('\n')

      const linkHtml = callsToAction.length
        ? '<ul>' + callsToAction + '</ul>'
        : ''

      const el = document.createElement('div')
      // el.innerHTML = `<h2><a href="${url}">${h1}</a></h2> <p>${summary}<a href="${url}">Read more</a>.</p>${linkHtml}</ul>`
      el.innerHTML = `<h2>${h1}</h2> <p>${summary} <a href="${url}">Read more</a>.</p>${linkHtml}</ul>`
      document.body.appendChild(el)
      const range = document.createRange()
      const selection = document.getSelection()
      range.selectNode(el)
      selection.removeAllRanges()
      selection.addRange(range)
      var successful = document.execCommand('copy')
      document.body.removeChild(el)
      if (!successful) {
        navigator.clipboard
          .writeText(text)
          .then(() => {
            alert('Text copied to clipboard')
          })
          .catch(err => {
            alert('Error in copying text: ', err)
          })
        console.warn('rich text copy was unsuccessful')
      }
      alert('Copied Successfully')

      if (typeof selection.removeRange === 'function') {
        selection.removeRange(range)
      } else {
        selection.removeAllRanges()
      }
    },
  },
}
</script>

<style lang="scss">
@import '../../../design/_variables.scss';
.asd20-share {
  position: relative;
  width: min-content;
  & > .asd20-button {
    padding: 0.375rem 0.375rem !important;
    border-radius: 5rem !important;
    background: rgba(255, 255, 255, 0.9) !important;
    .asd20-button__label {
      font-size: 0.875em !important;
      padding-right: 0.5rem;
    }
    &:hover,
    &:focus {
      color: var(--website-button__foreground-color) !important;
    }
  }

  .share-menu {
    position: absolute;
    display: flex;
    flex-direction: column;
    align-items: stretch;
    justify-content: stretch;
    width: 20rem;
    width: max-content;
    background: white;
    top: calc(100% + 1rem);
    right: 0;
    border-radius: var(--website-shape__radius-s, 0px);
    box-shadow: 0 0.25rem 1rem 0 rgba(0, 0, 0, 0.25);
    z-index: 1000;
    &::before {
      content: '';
      display: block;
      position: absolute;
      top: -1.5rem;
      right: 0.5rem;
      width: 0;
      height: 0;
      border: 1rem solid transparent;
      border-bottom-color: white;
    }
    h2 {
      margin: 0;
      padding: 1rem 1rem 0.5rem 1rem;
      font-size: 0.75rem;
      opacity: 0.85;
      color: var(--website-page__foreground-color);
    }
    & > .asd20-button {
      width: auto;
      background: white;
      &:hover,
      &:focus {
        color: var(--website-button__foreground-color);
        background: rgb(240, 240, 240);
      }
    }
  }
}
</style>
